<div mat-dialog-title class="title-dialog">
    <span class="ff-bold fs-18">{{ dialogTitle }}</span>
</div>
<div mat-dialog-content>
    <mat-radio-group [(ngModel)]="selectedOption" class="d-flex flex-column" color="primary">
        <mat-radio-button *ngFor="let element of dialogOptions" [value]="element.accountId">
            <div class="d-flex align-items-center gap-1">
                <div>{{ element.firstName + " " + element.lastName }}</div>
                <div class="emailDiv">{{ element.email | extractUsername }}</div>
            </div>
        </mat-radio-button>
    </mat-radio-group>
</div>

<div mat-dialog-actions align="end" class="action-dialog">
    <button mat-dialog-close>Cancel</button>
    <button class="tse-btn-primary" [disabled]="!selectedOption" [class.disabled]="!selectedOption"
            (click)="handleResponse()">Done
    </button>
</div>